import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initializeLogger } from "./config/loggerConfig";

// Optional: Initialize logger with environment-specific settings
// Logger works with defaults if this is not called
initializeLogger();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
